// extracted by mini-css-extract-plugin
module.exports = {"total__table":"Total_total__table__2yHq1"};